export const getDefaultProductlineIdFromChainId = (chainId: number | undefined | null) => (chainId ? -chainId : null);
